
export default function ResidentialShowcase() {
  const projects = [
    {
      title: 'Modern Sandton Penthouse',
      scope: 'Full interior renovation with structural alterations',
      duration: '14 weeks',
      image: 'https://public.readdy.ai/ai/img_res/c89d71e67d4398d9ef65cc1d0116db3c.jpg'
    },
    {
      title: 'Bryanston Family Estate',
      scope: 'Kitchen, bathrooms, and outdoor entertainment area',
      duration: '10 weeks',
      image: 'https://readdy.ai/api/search-image?query=luxury%20family%20home%20kitchen%20renovation%20white%20marble%20countertops%20gold%20hardware%20custom%20cabinetry%20pendant%20lighting%20island%20seating%20premium%20appliances%20warm%20wood%20accents%20sophisticated%20design%20high%20end%20residential%20transformation&width=700&height=500&seq=res-show-002&orientation=landscape'
    },
    {
      title: 'Fourways Heritage Restoration',
      scope: 'Heritage-sensitive renovation with modern upgrades',
      duration: '18 weeks',
      image: 'https://readdy.ai/api/search-image?query=beautifully%20restored%20heritage%20home%20interior%20blending%20classic%20architecture%20with%20modern%20luxury%20marble%20bathroom%20freestanding%20bath%20gold%20fixtures%20sophisticated%20lighting%20premium%20finishes%20elegant%20restoration%20high%20end%20residential%20transformation%20warm%20tones&width=700&height=500&seq=res-show-003&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-28 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-20">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">Our Work</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
            Featured <span className="font-serif text-[#D4AF37]">Residential Projects</span>
          </h2>
        </div>

        <div className="space-y-10 md:space-y-12">
          {projects.map((project, index) => (
            <article key={index} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div className={`${index % 2 === 1 ? 'lg:order-2' : 'lg:order-1'}`}>
                <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-xl">
                  <div className="w-full h-[240px] sm:h-[300px] md:h-[360px]">
                    <img
                      src={project.image}
                      alt={`${project.title} - Residential Renovation Johannesburg`}
                      title={`${project.title} luxury residential renovation`}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
              </div>
              <div className={`space-y-4 md:space-y-6 ${index % 2 === 1 ? 'lg:order-1' : 'lg:order-2'}`}>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-0.5 bg-[#D4AF37]"></div>
                  <span className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase">
                    Project {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-[#2A2A2A]">{project.title}</h3>
                <p className="text-base md:text-lg text-gray-600 leading-relaxed">{project.scope}</p>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-time-line text-[#D4AF37]"></i>
                  <span>Completed in {project.duration}</span>
                </div>
                <a
                  href="/#contact"
                  className="inline-flex items-center gap-2 px-6 md:px-8 py-3 bg-[#D4AF37] text-white text-sm font-semibold rounded-full hover:bg-[#B8941F] transition-all whitespace-nowrap cursor-pointer"
                >
                  Start Your Project
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
